var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-6 h-6",
    height: 48,
    viewBox: "0 0 50 50",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Res_User_48_Dark_svg__cls-1{fill:#232f3e}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Res_User_48_Dark_svg__Working"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Res_User_48_Dark_svg__cls-1",
    d: "M47.5 48.44h-45a1 1 0 01-1-1v-3a22.73 22.73 0 0117.36-22.1 1.06 1.06 0 01.72.09 11.29 11.29 0 0010.82 0 1 1 0 01.71-.09A22.73 22.73 0 0148.5 44.45v3a1 1 0 01-1 .99zm-44-2h43v-2A20.71 20.71 0 0031 24.39a13.51 13.51 0 01-6 1.43 13.21 13.21 0 01-6-1.43A20.72 20.72 0 003.5 44.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Res_User_48_Dark_svg__cls-1",
    d: "M25 25.75a12.18 12.18 0 01-5.9-1.5 12.13 12.13 0 1118.06-10.58 12 12 0 01-6.32 10.58 12.38 12.38 0 01-5.84 1.5zm0-22.19a10.08 10.08 0 00-5 18.94 10.33 10.33 0 009.85 0A10.08 10.08 0 0025 3.56z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f4af069f1f42fb4246c40de3d2564dc1.svg";
export { ForwardRef as ReactComponent };